import styles from './_blurredContent.module.scss'
import { t } from '../../../../utils/index'
import { useContext } from 'react'
import { ModalsContext } from '../../../../utils/modals'
import { useRouter } from 'next/router'

interface BlurredContentProps {
  message: string
  isActive: boolean
  isSignedIn: boolean
  isOnFreePlan?: boolean
  topIndent?: string
  children?: React.ReactNode
}

const BlurredContent: React.FC<BlurredContentProps> = ({
  isActive,
  isSignedIn,
  isOnFreePlan,
  message,
  topIndent,
  children
}) => {
  const { openModal, closeModal } = useContext(ModalsContext)
  const router = useRouter()

  const openSignInModal = () => {
    openModal({
      name: 'SignIn',
      props: {
        onClose: closeModal
      },
      modalTitle: t('Sign In')
    })
  }

  return isActive ? (
    <div className={styles.blurredContent}>
      <div
        className={styles.messageContainer}
        style={topIndent ? { top: topIndent } : null}
      >
        <div
          onClick={
            isOnFreePlan
              ? () => router.push('/account#subscription')
              : openSignInModal
          }
          className={styles.message}
        >
          {message}
        </div>
      </div>

      {!isSignedIn && (
        <>
          <div className={styles.blurredContentLink}>
            <a
              className={'button is-primary is-large'}
              href="https://worshiponline.com"
            >
              {t('Start Free Trial')}
            </a>
            <div className={styles.demoSongLink}>
              <a className={'button is-primary is-large is-cyan'} href="/demo">
                {t('View Demo Song')}
              </a>
            </div>
          </div>
        </>
      )}

      {children}
    </div>
  ) : (
    <>{children}</>
  )
}

export default BlurredContent
